import Domains from "./constants/domain";
export const Images = () => {
  const domain = window.location.hostname;

  if (domain.includes(Domains.ALDI)) {
    return {
      bg_img1: require("../assets/aldi/images/bg_1.png"),
      bg_img2: require("../assets/aldi/images/bg_2.jpg"),
      bg_img3: require("../assets/aldi/images/bg_3.jpg"),
      mmLogo: require("../assets/aldi/images/aldimm-logo.png"),
      MMLogo: require("../assets/aldi/images/aldimm-logo.png"),
      LoginBanner: require("../assets/aldi/images/loginbgnew.jpg"),
      Dashboard_Icon: require("../assets/aldi/images/Dashboard_Icon.png"),
      Report_Icon: require("../assets/aldi/images/Report_Icon.png"),
      ScoreCard_Icon: require("../assets/aldi/images/ScoreCard_Icon.png"),
      FixIt_Icon: require("../assets/aldi/images/FixIt_Icon.png"),
      m1: require("../assets/aldi/images/m-1.png"),
      m2: require("../assets/aldi/images/m-2.png"),
      m3: require("../assets/aldi/images/m-3.png"),
      m4: require("../assets/aldi/images/m-4.png"),
      Checklist: require("../assets/aldi/images/Checklist.png"),
      Bsc_Icon: require("../assets/aldi/images/BSC_Icon.png"),
      Trend_Icon: require("../assets/aldi/images/Trend_Icon.png"),
      DownArrow: require('../assets/aldi/images/DownArrow.png'),
      UpArrow: require('../assets/aldi/images/UpArrow.png'),
      managearea: require('../assets/aldi/images/managearea.png'),
      managevenue: require('../assets/aldi/images/managevenue.png'),
      Category_Icon: require('../assets/aldi/images/Category_Icon.png'),
      Comparision_Icon: require('../assets/aldi/images/comparisions.png')

    };
  } else if (domain.includes(Domains.BLOOMS)) {
    return {
      bg_img1: require("../assets/blooms/images/bg_1.png"),
      bg_img2: require("../assets/blooms/images/bg_2.png"),
      bg_img3: require("../assets/blooms/images/bg_3.png"),
      LoginBanner: require("../assets/blooms/images/Blooms.webp"),
      MMLogo: require("../assets/blooms/images/MM_logo.png"),
      mmLogo: require("../assets/blooms/images/Blooms_logo.png"),
      Dashboard_Icon: require("../assets/blooms/images/Dashboard_Icon.png"),
      Report_Icon: require("../assets/blooms/images/Report_Icon.png"),
      ScoreCard_Icon: require("../assets/blooms/images/ScoreCard_Icon.png"),
      FixIt_Icon: require("../assets/blooms/images/FixIt_Icon.png"),
      m1: require("../assets/blooms/images/m-1.png"),
      m2: require("../assets/blooms/images/m-2.png"),
      m3: require("../assets/blooms/images/m-3.png"),
      m4: require("../assets/blooms/images/m-4.png"),
      Checklist: require("../assets/blooms/images/Checklist.png"),
      DownArrow: require('../assets/blooms/images/DownArrow.png'),
      UpArrow: require('../assets/blooms/images/UpArrow.png'),
      managearea: require('../assets/blooms/images/managearea.png'),
      managevenue: require('../assets/blooms/images/managevenue.png'),
      Category_Icon: require('../assets/blooms/images/Category_Icon.png'),
      Comparision_Icon: require('../assets/blooms/images/comparisions.png')


    };
  } else if (domain.includes(Domains.SHOPPER)) {
    return {
      AldiBanner2: require("../assets/images/shoppers-image-1.jpg"),
      AldiBanner1: require("../assets/images/shoppers-image.jpg"),
      mmLogo: require("../assets/common/images/MM-logo.png"),
    };
  } else if (domain.includes(Domains.MM)) {
    return {
      bg_img1: require("../assets/common/images/bg_1.jpg"),
      bg_img2: require("../assets/common/images/bg_2.jpg"),
      bg_img3: require("../assets/common/images/bg_3.jpeg"),
      MMLogo: require("../assets/common/images/MM-logo.png"),
      mmLogo: require("../assets/common/images/MM-logo.png"),
      Dashboard_Icon: require("../assets/common/images/Dashboard_Icon.png"),
      Report_Icon: require("../assets/common/images/Report_Icon.png"),
      ScoreCard_Icon: require("../assets/common/images/ScoreCard_Icon.png"),
      FixIt_Icon: require("../assets/common/images/FixIt_Icon.png"),
      m1: require("../assets/common/images/m-1.png"),
      m2: require("../assets/common/images/m-2.png"),
      m3: require("../assets/common/images/m-3.png"),
      m4: require("../assets/common/images/m-4.png"),
      Checklist: require("../assets/common/images/Checklist.png"),
      DownArrow: require('../assets/common/images/DownArrow.png'),
      UpArrow: require('../assets/common/images/UpArrow.png'),
      managearea: require('../assets/common/images/managearea.png'),
      managevenue: require('../assets/common/images/managevenue.png'),
      Category_Icon: require('../assets/common/images/Category_Icon.png'),
      Comparision_Icon: require('../assets/common/images/comparisions.png'),
      Trend_Icon: require("../assets/common/images/Trend_Icon.png"),
    };
  } else {
    return {
      bg_img1: require("../assets/common/images/bg_1.jpg"),
      bg_img2: require("../assets/common/images/bg_2.jpg"),
      bg_img3: require("../assets/common/images/bg_3.jpeg"),
      MMLogo: require("../assets/common/images/MM-logo.png"),
      mmLogo: require("../assets/common/images/MM-logo.png"),
      Dashboard_Icon: require("../assets/common/images/Dashboard_Icon.png"),
      Report_Icon: require("../assets/common/images/Report_Icon.png"),
      ScoreCard_Icon: require("../assets/common/images/ScoreCard_Icon.png"),
      FixIt_Icon: require("../assets/common/images/FixIt_Icon.png"),
      m1: require("../assets/common/images/m-1.png"),
      m2: require("../assets/common/images/m-2.png"),
      m3: require("../assets/common/images/m-3.png"),
      m4: require("../assets/common/images/m-4.png"),
      Checklist: require("../assets/common/images/Checklist.png"),
      StarRating: require("../assets/common/images/StarRating.png"),
      DownArrow: require('../assets/common/images/DownArrow.png'),
      UpArrow: require('../assets/common/images/UpArrow.png'),
      managearea: require('../assets/common/images/managearea.png'),
      managevenue: require('../assets/common/images/managevenue.png'),
      Category_Icon: require('../assets/common/images/Category_Icon.png'),
      Comparision_Icon: require('../assets/common/images/comparisions.png'),
      Trend_Icon: require("../assets/common/images/Trend_Icon.png"),

    };
    //   return require('../assets/common/images/default-image.jpg');
  }
};
